import newInterval from './interval.js';
import { durationMinute, durationSecond } from './duration.js';
var minute = newInterval(function (date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
}, function (date, step) {
  date.setTime(+date + step * durationMinute);
}, function (start, end) {
  return (end - start) / durationMinute;
}, function (date) {
  return date.getMinutes();
});
minute.range;
export { minute as default };
//# sourceMappingURL=minute.js.map
